import type React from "react";
import type { TLocale } from "../../../shared";

export const flagIcons: Record<TLocale, React.ReactNode> = {
  en: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect y="7.692%" width="100%" height="90%" fill="#fff" />
      <rect width="100%" height="7.692%" fill="#D02F44" />
      <rect y="15.384%" width="100%" height="7.692%" fill="#D02F44" />
      <rect y="30.769%" width="100%" height="7.692%" fill="#D02F44" />
      <rect y="46.153%" width="100%" height="7.692%" fill="#D02F44" />
      <rect y="61.538%" width="100%" height="7.692%" fill="#D02F44" />
      <rect y="76.923%" width="100%" height="7.692%" fill="#D02F44" />
      <rect y="92.307%" width="100%" height="7.692%" fill="#D02F44" />
      <rect width="42.8%" height="46.3%" fill="#46467F" />
      <path
        fill="#fff"
        d="M2.67 2a.67.67 0 1 1-1.34 0 .67.67 0 0 1 1.34 0Zm2.66 0A.67.67 0 1 1 4 2a.67.67 0 0 1 1.33 0Zm2 .67a.67.67 0 1 0 0-1.34.67.67 0 0 0 0 1.34ZM10.67 2a.67.67 0 1 1-1.34 0 .67.67 0 0 1 1.34 0ZM3.33 4a.67.67 0 1 0 0-1.33.67.67 0 0 0 0 1.33Zm3.34-.67a.67.67 0 1 1-1.34 0 .67.67 0 0 1 1.34 0Zm2 .67a.67.67 0 1 0 0-1.33.67.67 0 0 0 0 1.33Zm2 .67a.67.67 0 1 1-1.34 0 .67.67 0 0 1 1.34 0Zm-3.34.66a.67.67 0 1 0 0-1.33.67.67 0 0 0 0 1.33Zm-2-.66a.67.67 0 1 1-1.33 0 .67.67 0 0 1 1.33 0ZM2 5.33A.67.67 0 1 0 2 4a.67.67 0 0 0 0 1.33ZM4 6a.67.67 0 1 1-1.33 0A.67.67 0 0 1 4 6Zm2 .67a.67.67 0 1 0 0-1.34.67.67 0 0 0 0 1.34ZM9.33 6A.67.67 0 1 1 8 6a.67.67 0 0 1 1.33 0ZM10 8a.67.67 0 1 0 0-1.33A.67.67 0 0 0 10 8Zm-2-.67a.67.67 0 1 1-1.33 0 .67.67 0 0 1 1.33 0ZM4.67 8a.67.67 0 1 0 0-1.33.67.67 0 0 0 0 1.33Zm-2-.67a.67.67 0 1 1-1.34 0 .67.67 0 0 1 1.34 0Z"
      />
    </svg>
  ),
  he: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
    >
      <rect
        x="0.25"
        y="0.25"
        width="27.5"
        height="19.5"
        rx="1.75"
        fill="white"
        stroke="#F5F5F5"
        strokeWidth="0.5"
      />
      <mask
        id="mask0_339_3426"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="20"
      >
        <rect
          x="0.25"
          y="0.25"
          width="27.5"
          height="19.5"
          rx="1.75"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
        />
      </mask>
      <g mask="url(#mask0_339_3426)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4H28V0H0V4Z"
          fill="#0E46D4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 20H28V16H0V20Z"
          fill="#0E46D4"
        />
        <path
          d="M10.3752 11.8381L10.1001 12.3333L10.6666 12.3333L17.3333 12.3333L17.8998 12.3333L17.6247 11.8381L14.2913 5.8381L13.9999 5.31361L13.7085 5.8381L10.3752 11.8381Z"
          stroke="#093EC5"
          strokeWidth="0.666667"
        />
        <path
          d="M10.3752 8.1619L10.1001 7.66668L10.6666 7.66668L17.3333 7.66668L17.8998 7.66668L17.6247 8.1619L14.2913 14.1619L13.9999 14.6864L13.7085 14.1619L10.3752 8.1619Z"
          stroke="#093EC5"
          strokeWidth="0.666667"
        />
      </g>
    </svg>
  ),
  de: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect width="100%" height="33.33%" fill="#262626" />
      <rect y="33.33%" width="100%" height="33.33%" fill="#F01515" />
      <rect y="66.66%" width="100%" height="33.33%" fill="#FFD521" />
    </svg>
  ),
  es: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <path fill="#DD172C" d="M0 5.33h28V0H0v5.33ZM0 20h28v-5.33H0V20Z" />
      <path fill="#FFD133" d="M0 14.67h28V5.33H0v9.34Z" />
      <path fill="#FFEDB1" d="M7.33 9.33h1.34V10H7.33v-.67Z" />
      <path
        stroke="#A41517"
        strokeWidth=".67"
        d="M6.06 9.36A.33.33 0 0 1 6.39 9h1.89c.2 0 .34.17.33.36l-.17 2.06a1 1 0 0 1-1 .91h-.21a1 1 0 0 1-1-.91l-.17-2.06Z"
      />
      <path fill="#A41517" d="M6 10h2.67v.67H8L7.33 12l-.66-1.33H6V10Z" />
      <rect width="1.33" height="4.67" x="4" y="8" fill="#A41517" rx=".67" />
      <rect width="1.33" height="4.67" x="9.33" y="8" fill="#A41517" rx=".67" />
      <path
        fill="#A41517"
        d="M6 7.73c0-.59.48-1.06 1.07-1.06h.53c.59 0 1.07.47 1.07 1.06 0 .15-.12.27-.27.27H6.27A.27.27 0 0 1 6 7.73Z"
      />
    </svg>
  ),
  tr: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect width="100%" height="100%" fill="#E92434" />
      <path
        fill="#fff"
        d="m19.02 10.77-1.22 1.48.08-1.92-1.8-.7 1.86-.52.12-1.92 1.06 1.6L21 8.31l-1.2 1.5 1.03 1.63-1.8-.67Z"
      />
      <path
        fill="#fff"
        d="M17.4 13.68a5.99 5.99 0 1 1 0-7.36 5.2 5.2 0 0 0-3.07-.99c-2.76 0-5 2.1-5 4.67 0 2.58 2.24 4.67 5 4.67a5.2 5.2 0 0 0 3.07-.99Z"
      />
    </svg>
  ),
  pt: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect width="40%" height="100%" fill="#128415" />
      <rect width="60%" height="100%" x="40%" fill="#FF2936" />
      <circle cx="40%" cy="50%" r="13%" stroke="#FAF94F" fill="none" />
      <g transform="translate(4.54 0)">
        <path
          fill="#fff"
          d="M5.33 8.33c0-.18.15-.33.34-.33h2c.18 0 .33.15.33.33v2.34a1.33 1.33 0 0 1-2.67 0V8.33Z"
        />
        <path
          fill="#1D50B5"
          d="M6.67 10.67c.36 0 .66-.97.66-1.34a.67.67 0 1 0-1.33 0c0 .37.3 1.34.67 1.34Z"
        />
      </g>
    </svg>
  ),
  hr: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 20">
      <rect y="33.33%" width="100%" height="33.33%" fill="#fff" />
      <g fillRule="evenodd">
        <rect width="100%" height="33.33%" fill="#FF202D" />
        <path
          fill="#1895DB"
          d="m10.67 5.33.66-.66.67.66v1.34h-1.33V5.33Zm2.66 0 .67-.66.67.66v1.34h-1.34V5.33Zm3.34-.66-.67.66v1.34h1.33V5.33l-.66-.66Z"
          opacity=".5"
        />
        <path
          fill="#191F94"
          d="m12.67 4.67-.67.66v1.34h1.33V5.33l-.66-.66Zm2.66 0-.66.66v1.34H16V5.33l-.67-.66Z"
          opacity=".5"
        />
        <rect y="66.66%" width="100%" height="33.33%" fill="#2027AC" />
        <path
          fill="#FD0D1B"
          d="M12 6.67h-.67L10.67 8H12v1.33h-1.33v1.34H12V12h-1.33v1.33H12v1.34h1.33v-1.34h1.34v1.34H16v-1.34h1.33V12H16v-1.33h1.33V9.33H16V8h1.33l-.66-1.33H16V8h-1.33V6.67h-1.34V8H12V6.67Zm1.33 2.66V8h1.34v1.33h-1.34Zm0 1.34V9.33H12v1.34h1.33Zm1.34 0h-1.34V12H12v1.33h1.33V12h1.34v1.33H16V12h-1.33v-1.33Zm0 0H16V9.33h-1.33v1.34Z"
        />
      </g>
    </svg>
  ),
  sq: (
    <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg">
      <path fill="#EE343C" d="M0 0h28v20H0z" />
      <path
        fill="#262626"
        d="M12.39 4.39a.67.67 0 0 0-.84-.09l-.6.4a.67.67 0 0 0 .08 1.15l1.27.63c.22.12.37.35.37.6v.25c0 .37-.3.67-.67.67h-.5c-.11 0-.21-.02-.3-.07L9.1 6.88a.67.67 0 0 0-.77.13l-.34.34a.67.67 0 0 0 .17 1.06l.94.48c.4.2.44.75.07 1-.43.29-.3.95.2 1.05l.57.11c.54.11.7.8.25 1.14l-.5.37a.43.43 0 0 0 .36.76l1.26-.31c.48-.12.86.4.58.82-.24.36.02.84.45.84h.58c.25 0 .47.15.54.38.17.52.9.52 1.08 0 .07-.23.3-.38.54-.38h.58c.43 0 .69-.48.45-.84a.54.54 0 0 1 .58-.82l1.26.31.1.01c.41 0 .59-.52.26-.77l-.5-.37a.64.64 0 0 1 .25-1.14l.56-.1c.51-.11.64-.77.21-1.06a.58.58 0 0 1 .07-1l.94-.48c.4-.2.5-.74.17-1.06L19.67 7a.67.67 0 0 0-.77-.13l-2.1 1.05c-.09.05-.19.07-.3.07H16a.67.67 0 0 1-.67-.67v-.25c0-.25.15-.48.37-.6l1.27-.63c.46-.23.5-.87.07-1.15l-.59-.4a.67.67 0 0 0-.84.09l-1.14 1.14a.67.67 0 0 1-.94 0l-1.14-1.14Z"
      />
    </svg>
  ),
  sr: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect
        width="27.5"
        height="19.5"
        x=".25"
        y=".25"
        fill="#fff"
        stroke="#F5F5F5"
        strokeWidth=".5"
        rx="1.75"
      />
      <g>
        <path
          fill="#17508F"
          fillRule="evenodd"
          d="M0 13.33h28V6.66H0v6.67Z"
          clipRule="evenodd"
        />
        <path
          fill="#E1444D"
          fillRule="evenodd"
          d="M0 6.67h28V0H0v6.67Z"
          clipRule="evenodd"
        />
        <path
          fill="red"
          fillRule="evenodd"
          d="M6 10c0-.65.34-2.08.54-2.84.07-.3.33-.5.64-.5h2.98c.3 0 .56.2.64.5.19.75.53 2.18.53 2.84 0 .74-.5 2.7-.63 3.2a.57.57 0 0 1-.11.23c-.26.31-1.1 1.23-1.92 1.23-.84 0-1.67-.92-1.92-1.23a.57.57 0 0 1-.12-.22A19.7 19.7 0 0 1 6 10Z"
          clipRule="evenodd"
        />
        <mask
          id="lang-sr-mask1"
          width="6"
          height="9"
          x="6"
          y="6"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M6 10c0-.65.34-2.08.54-2.84.07-.3.33-.5.64-.5h2.98c.3 0 .56.2.64.5.19.75.53 2.18.53 2.84 0 .74-.5 2.7-.63 3.2a.57.57 0 0 1-.11.23c-.26.31-1.1 1.23-1.92 1.23-.84 0-1.67-.92-1.92-1.23a.57.57 0 0 1-.12-.22A19.7 19.7 0 0 1 6 10Z"
            clipRule="evenodd"
          />
        </mask>
        <g
          stroke="#fff"
          strokeLinecap="square"
          strokeWidth="1.33"
          mask="url(#lang-sr-mask1)"
        >
          <path d="M11.33 7.33 6 14M6 7.33 11.33 14" />
        </g>
      </g>
    </svg>
  ),
  // he: (
  //   <svg   viewBox="0 0 28 20">
  //     <rect width="100%" height="100%" fill="white" stroke="#F5F5F5" strokeWidth="0.5" />
  //     <path d="M0 4H28V0H0V4Z" fill="#0E46D4" />
  //     <path d="M0 20H28V16H0V20Z" fill="#0E46D4" />
  //     <path
  //       d="M10.3752 11.8381L10.1001 12.3333L10.6666 12.3333L17.3333 12.3333L17.8998 12.3333L17.6247 11.8381L14.2913 5.8381L13.9999 5.31361L13.7085 5.8381L10.3752 11.8381Z"
  //       fill="none"
  //       stroke="#093EC5"
  //       strokeWidth="0.666667"
  //     />
  //     <path
  //       d="M10.3752 8.1619L10.1001 7.66668L10.6666 7.66668L17.3333 7.66668L17.8998 7.66668L17.6247 8.1619L14.2913 14.1619L13.9999 14.6864L13.7085 14.1619L10.3752 8.1619Z"
  //       fill="none"
  //       stroke="#093EC5"
  //       strokeWidth="0.666667"
  //     />
  //   </svg>
  // ),
  "sr-en": (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect
        width="27.5"
        height="19.5"
        x=".25"
        y=".25"
        fill="#fff"
        stroke="#F5F5F5"
        strokeWidth=".5"
        rx="1.75"
      />
      <g>
        <path
          fill="#17508F"
          fillRule="evenodd"
          d="M0 13.33h28V6.66H0v6.67Z"
          clipRule="evenodd"
        />
        <path
          fill="#E1444D"
          fillRule="evenodd"
          d="M0 6.67h28V0H0v6.67Z"
          clipRule="evenodd"
        />
        <path
          fill="red"
          fillRule="evenodd"
          d="M6 10c0-.65.34-2.08.54-2.84.07-.3.33-.5.64-.5h2.98c.3 0 .56.2.64.5.19.75.53 2.18.53 2.84 0 .74-.5 2.7-.63 3.2a.57.57 0 0 1-.11.23c-.26.31-1.1 1.23-1.92 1.23-.84 0-1.67-.92-1.92-1.23a.57.57 0 0 1-.12-.22A19.7 19.7 0 0 1 6 10Z"
          clipRule="evenodd"
        />
        <mask
          id="lang-sr-mask1"
          width="6"
          height="9"
          x="6"
          y="6"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M6 10c0-.65.34-2.08.54-2.84.07-.3.33-.5.64-.5h2.98c.3 0 .56.2.64.5.19.75.53 2.18.53 2.84 0 .74-.5 2.7-.63 3.2a.57.57 0 0 1-.11.23c-.26.31-1.1 1.23-1.92 1.23-.84 0-1.67-.92-1.92-1.23a.57.57 0 0 1-.12-.22A19.7 19.7 0 0 1 6 10Z"
            clipRule="evenodd"
          />
        </mask>
        <g
          stroke="#fff"
          strokeLinecap="square"
          strokeWidth="1.33"
          mask="url(#lang-sr-mask1)"
        >
          <path d="M11.33 7.33 6 14M6 7.33 11.33 14" />
        </g>
      </g>
    </svg>
  ),
  el: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect
        width="27.5"
        height="19.5"
        x=".25"
        y=".25"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
      />
      <path
        fill="#1c6dc1"
        d="M5.33 0H0v5.33h5.33V0Zm8 0H8v5.33h5.33V8H8v5.33h20v-2.66H13.33V8H28V5.33H13.33V2.67H28V0H13.33ZM28 16H0v2.67h28V16ZM5.33 8H0v5.33h5.33V8Z"
      />
    </svg>
  ),
  zh: (
    <svg viewBox="0 0 28 20">
      <rect width="100%" height="100%" fill="#F1361D" />
      <path
        fill="#FFDC42"
        d="m10.07 3.1.97.17.73.66.16-.97.66-.73-.96-.16-.73-.66-.17.96-.66.73Zm2.6 3.39.84-.51.98.02-.51-.84.02-.98-.84.5-.98-.01.51.84-.02.98Zm-1.14 5.48-.82.54-.01-.98-.54-.82.98-.01.82-.54.01.98.54.82-.98.01Zm.71-2.54.98-.1.88.43-.11-.98.44-.88-.98.11-.88-.44.1.98-.43.88ZM6.67 8.23 4.32 9.9l.86-2.75-2.32-1.72 2.89-.03.92-2.73.91 2.73 2.9.03-2.33 1.72.87 2.75-2.35-1.67Z"
      />
    </svg>
  ),
  ru: (
    <svg viewBox="0 0 28 20">
      <rect height="33.33%" width="100%" fill="white" />
      <rect y="33.33%" height="33.33%" width="100%" fill="#0C47B7" />
      <rect y="66.66%" height="33.33%" width="100%" fill="#E53B35" />
    </svg>
  ),
  ro: (
    <svg viewBox="0 0 28 20">
      <rect width="33.33%" height="100%" fill="#083780" />
      <rect x="33.33%" width="33.33%" height="100%" fill="#FFD147" />
      <rect x="66.66%" width="33.33%" height="100%" fill="#DE1D42" />
    </svg>
  ),
  uk: (
    <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="50%" fill="#0066CC" />
      <rect y="50%" width="100%" height="50%" fill="#FFCC00" />
    </svg>
  ),
  fr: (
    <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" width="33.33%" height="100%" fill="#0055A4" />
      <rect x="33.33%" width="33.33%" height="100%" fill="white" />
      <rect x="66.66%" width="33.33%" height="100%" fill="#EF4135" />
    </svg>
  ),
  ar: (
    <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="100%"
        height="100%"
        fill="rgba(25, 191, 191, 1)"
        strokeWidth="0.5"
      />
      <circle
        cx="50%"
        cy="50%"
        r="7"
        fill="none"
        stroke="white"
        strokeWidth="1.25"
      />
      <ellipse
        cx="50%"
        cy="50%"
        fill="none"
        rx="2.5"
        ry="7"
        stroke="white"
        strokeWidth="1.25"
      />
      <line
        x1="25%"
        x2="75%"
        y1="50%"
        y2="50%"
        stroke="white"
        strokeWidth="1.25"
      />
    </svg>
  ),
  pl: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <rect width="28" height="10" fill="#F5F5F5" />
      <rect width="28" height="10" y="10" fill="#DC143C" />
    </svg>
  ),
};
